<div class="image__close" (click)="imageService.close()"><i class="icon-close"></i></div>
<div (window:keyup.esc)="imageService.close()" class="image__overlay" (click)="imageService.close()"></div>
<img [src]="imageService.imageUrl" />
